var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9.16675,
    width: 10,
    height: 3.33333,
    fill: "#838B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6331 7.46665C15.9331 6.69165 14.7831 6.31665 13.0998 6.31665H6.89979C5.21646 6.31665 4.06646 6.69165 3.36646 7.46665C2.55812 8.36665 2.58312 9.56665 2.67479 10.4L3.25812 15.0416C3.43312 16.6666 4.09146 18.3333 7.67479 18.3333H12.3248C15.9081 18.3333 16.5665 16.6666 16.7415 15.05L17.3248 10.3917C17.4165 9.56665 17.4331 8.36665 16.6331 7.46665ZM7.01646 10.9583H7.00812C6.54979 10.9583 6.17479 10.5833 6.17479 10.125C6.17479 9.66665 6.54979 9.29165 7.00812 9.29165C7.47479 9.29165 7.84979 9.66665 7.84979 10.125C7.84979 10.5833 7.47479 10.9583 7.01646 10.9583ZM12.8498 10.9583H12.8415C12.3831 10.9583 12.0081 10.5833 12.0081 10.125C12.0081 9.66665 12.3831 9.29165 12.8415 9.29165C13.3081 9.29165 13.6831 9.66665 13.6831 10.125C13.6831 10.5833 13.3081 10.9583 12.8498 10.9583Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4916 7.38317C13.1666 7.38317 12.9082 7.12484 12.9082 6.79984V5.73317C12.9082 4.9165 12.5582 4.13317 11.9582 3.58317C11.3416 3.02484 10.5499 2.7665 9.71655 2.8415C8.31656 2.97484 7.09156 4.39984 7.09156 5.88317V6.63317C7.09156 6.95817 6.83322 7.2165 6.50822 7.2165C6.18322 7.2165 5.92489 6.95817 5.92489 6.63317V5.88317C5.92489 3.79984 7.60822 1.87484 9.59989 1.68317C10.7582 1.57484 11.8749 1.9415 12.7332 2.72484C13.5832 3.4915 14.0666 4.5915 14.0666 5.73317V6.79984C14.0666 7.12484 13.8082 7.38317 13.4916 7.38317Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.b22a22b194adc37828fb9cb27dfe6613.svg";
export { ForwardRef as ReactComponent };